<template>
    <div class="dropdown w-full">
        <div class="relative">
            <button :class="inputClass" @click="toggleDropdown" ref="dropdownButton" :disabled="disabled">
                {{ selectedOpt ? selectedOpt[optionKey] : `Select ${fieldName}` }}
            </button>
            <div
                :class="['absolute top-0 right-0 pr-[15px] h-full !flex items-center justify-center gap-2', buttonIconClass]">
                <span class="cursor-pointer object-contain
                " @click="clearClicked" v-if="selectedOpt && !radioType">
                    <img src="../../assets/images/updated-cancel-deropdown.png" alt="Cross Icon"
                        class="w-[20px] h-[20px] object-cover">
                </span>
                <span class="cursor-pointer" @click="toggleDropdown" ref="iconDropdownButton" :disabled="disabled">
                    <svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                        <path
                            d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z" />
                    </svg>
                    <img v-if="imageSrc" :src="imageSrc" class="w-3 h-3 2xl:w-5 2xl:h-5 !block" />
                </span>
            </div>
        </div>
        <div v-if="isOpen" ref="dropdownMenu"
            :class="['dropdown-menu w-full !flex flex-col gap-2 !p-2 !absolute !rounded-xl  !border-customGray !shadow-custom', dropdownMenuClass]">
            <!-- Search Input -->
            <div class="relative" v-if="isSearchable">
                <input type="text" v-model="searchQuery" placeholder="Search..."
                    class="sticky top-0 w-full bg-customWhite p-2 pl-10 border border-customGray rounded-lg focus:outline-none focus:border-customPurple-dropdownCheck z-50"
                    @click.stop />
                <div class="absolute top-0 left-0 z-50 flex items-center h-full px-2">
                    <img src="../../assets/images/search-icon.png" alt="Search Icon" class="w-8 h-8 object-cover">
                </div>
            </div>

            <!-- Options List -->
            <template v-if="filteredOptions.length > 0">
                <ul :class="['list-inline !mb-0 !p-0', dropdownList]">
                    <li :class="['max-h-96 overflow-y-auto custom-scrollbar', wrapperList]">
                        <label :class="customLabelClass" v-for="(opt, index) in filteredOptions" :key="index">
                            <div :class="['absolute top-[10px] left-1.5 flex items-center', checkBoxPositionclass]">
                                <input :type="radioType ? 'radio' : 'checkbox'" :checked="isOptionSelected(opt)"
                                    @click="handleOptionClick(opt, $event)"
                                    :name="radioType ? `${fieldName}-radio-group` : undefined"
                                    :class="['cursor-pointer peer group transition-all appearance-none !m-0 !w-7 !h-7 text-xl !rounded-lg focus:!outline-none border !border-gray-500 checked:bg-customBlue-100 checked:!border-customBlue-100 group-hover:bg-white', customCheckboxClass]" />
                                <span
                                    :class="['cursor-pointer absolute text-white group-hover:!opacity-100 opacity-0 peer-checked:!opacity-100 top-[60%] left-[60%] transform -translate-x-[0.75rem] -translate-y-[0.8rem]', checkPositionClass]">
                                    <svg xmlns="http://www.w3.org/2000/svg" :class="['h-[20px] w-[20px] fill-white group-hover:fill-customBlue-100', customCheckboxSVGclass]"
                                        viewBox="0 0 20 20" fill="#ffffff" stroke="#ffffff" stroke-width="0.5">
                                        <path fill-rule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </div>
                            <span :class="['font-normal text-sm !ml-1 text-gray-700 group-hover:text-white', customLabelText]">{{ opt[optionKey]
                                }}</span>
                        </label>
                    </li>
                </ul>
            </template>

            <!-- No Results Found -->
            <div v-else class="py-2 text-center text-customGray-dark">
                No results found
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        optionKey: {
            type: String,
            required: true
        },
        selectValueKey: {
            type: String,
            default: ''
        },
        selectedOptions: {
            type: [Object, String, Number],
            default: null
        },
        fieldName: {
            type: String,
            required: true
        },
        updateOption: {
            type: Function,
            required: true
        },
        isSearchable: {
            type: Boolean,
            default: false
        },
        radioType: {
            type: Boolean,
            default: false
        },
        inputClass: {
            type: String,
            default: 'p-3 rounded-full w-full min-w-[200px] 2xl:min-w-[250px] border text-left border-customGray focus:outline-none'
        },
        dropdownMenuClass: {
            type: String,
            default: ''
        },
        customLabelClass: {
            type: String,
            default: 'group !mt-[5px] cursor-pointer transition-all duration-300 bg-white hover:!bg-customBlue-100 hover:!text-white text-black relative !w-full font-normal dropdown-item m-0 !rounded-lg leading-none accent-customBlue-100 !pl-[40px] !p-[14px]'
        },
        customCheckboxClass: {
            type: String,
            default: ''
        },
        customCheckboxSVGclass: {
            type: String,
            default: ''
        },
        checkBoxPositionclass: {
            type: String,
            default: ''
        },
        checkPositionClass: {
            type: String,
            default: ''
        },
        imageSrc: { // parent se image bhejni ho to
            type: String,
            default: ""
        },
        iconclass: {
            type: String,
            default: ""
        },
        buttonIconClass: {
            type: String,
            default: ""
        },
        dropdownList: {
            type: String,
            default: ""
        },
        customLabelText: {
            type: String,
            default: ""
        },
        wrapperList: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            isOpen: false,
            selectedOpt: null,
            searchQuery: ''
        }
    },
    computed: {
        filteredOptions() {
            if (!this.isSearchable || !this.searchQuery) return this.options
            return this.options.filter(opt =>
                String(opt[this.optionKey])
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase())
            )
        }
    },
    watch: {
        selectedOptions: {
            handler(newVal) {
                if (this.selectValueKey && newVal != null) {
                    let index = this.options.findIndex(
                        item => item[this.selectValueKey] == newVal
                    )
                    if (index != -1 && !this.$helper.isEmpty(newVal)) {
                        this.selectedOpt = this.options[index]
                    } else {
                        this.selectedOpt = null
                    }
                } else if (newVal != null) {
                    this.selectedOpt = newVal
                } else {
                    this.selectedOpt = null
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        clearClicked() {
            this.selectedOpt = null
            this.updateOption(this.fieldName, null)
        },
        closeDropdown(event) {
            if (
                this.isOpen &&
                this.$refs.dropdownMenu &&
                !this.$refs.dropdownMenu.contains(event.target) &&
                !this.$refs.dropdownButton.contains(event.target) &&
                !this.$refs.iconDropdownButton.contains(event.target)
            ) {
                this.close()
            }
        },
        toggleDropdown() {
            if (this.disabled) return
            this.isOpen ? this.close() : this.open()
        },
        open() {
            this.isOpen = true
            this.searchQuery = ''
        },
        close() {
            this.isOpen = false
            this.searchQuery = ''
        },
        handleOptionClick(opt, event) {
            // For radio buttons, prevent default to avoid native behavior
            if (this.radioType) {
                event.preventDefault()

                // Only update if not already selected
                if (!this.isOptionSelected(opt)) {
                    this.selectedOpt = opt
                    const res = this.selectValueKey ? opt[this.selectValueKey] : opt
                    this.updateOption(this.fieldName, res)
                    this.close()
                }
                return
            }

            // For checkboxes, allow toggle
            if (this.isOptionSelected(opt)) {
                this.selectedOpt = null
                this.updateOption(this.fieldName, null)
            } else {
                this.selectedOpt = opt
                const res = this.selectValueKey ? opt[this.selectValueKey] : opt
                this.updateOption(this.fieldName, res)
            }
            this.close()
        },
        isOptionSelected(opt) {
            if (!this.selectedOpt) return false
            if (this.selectValueKey) {
                return this.selectedOpt[this.selectValueKey] === opt[this.selectValueKey]
            }
            return this.selectedOpt === opt
        }
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown)
        window.addEventListener('scroll', this.closeDropdown, true)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeDropdown)
        window.removeEventListener('scroll', this.closeDropdown, true)
    }
}
</script>

<style scoped>
/* Custom scrollbar styles */
.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #CCCCCC;
    border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
